import React from "react";
import { useNavigate } from "react-router-dom";

const HomeBlogSection = () => {
    const navigate = useNavigate();

    return (
        <section className="home-blog-section">
            <div className="blog-container">

                <div className="heading">

                    <div className="section-header text-center">
                        <span className="ruby section-badge ">

                            Latest Blogs

                        </span>
                        <p className="pt-2">Insights, guides and career advice from our experts.</p>
                    </div>
                </div>



                <div className="blog-grid-advanced">

                    {/* Left Top Blog */}
                    <div className="blog-card text-card left-top">
                        <span className="blog-category">Career Growth</span>
                        <h4>How Mentorship Accelerates Professional Success</h4>
                        <p>
                            Discover how expert guidance helps professionals gain clarity,
                            build confidence, and achieve faster career growth.
                        </p>
                        <div className="blog-meta">
                            <span>May 12, 2026</span>
                        </div>
                        <button onClick={() => navigate("/blog")}>
                            Read More →
                        </button>
                    </div>

                    {/* Left Bottom Image Blog */}
                    <div className="blog-card image-card left-bottom">
                        <img src="https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8YmxvZ3xlbnwwfHwwfHx8MA%3D%3D" alt="" />
                        <div className="image-overlay">
                            <span className="blog-category">Learning</span>
                            <h4 style={{ color: "#fff" }}>Top Skills You Need in 2026</h4>
                        </div>
                        <button onClick={() => navigate("/blog")}>
                            Read More →
                        </button>
                    </div>

                    {/* Center Tall Featured Blog */}
                    <div className="blog-card image-card center-tall featured-card-fix">
                        <img src="https://images.unsplash.com/photo-1638342863994-ae4eee256688?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjB8fGJsb2d8ZW58MHx8MHx8fDA%3D" alt="" />
                        <div className="image-overlay">
                            <span className="blog-category">Featured</span>
                            <h3 style={{ color: "#fff" }}>Unlock Your Potential Through Personalized Learning</h3>
                            <button className="featured-btn" onClick={() => navigate("/blog")}>
                                Explore Article →
                            </button>
                        </div>
                    </div>

                    {/* Center Bottom Blog */}
                    <div className="blog-card text-card center-bottom">
                        <span className="blog-category">Guidance</span>
                        <h4>Why Personalized Learning Matters More Than Ever</h4>
                        <p>
                            Tailored learning paths improve retention, engagement, and
                            long-term success in competitive industries.
                        </p>
                        <div className="blog-meta">
                            <span>May 08, 2026</span>
                        </div>
                        <button onClick={() => navigate("/blog")}>
                            Read More →
                        </button>
                    </div>

                    {/* Right Top Blog */}
                    <div className="blog-card text-card right-top">
                        <span className="blog-category">Productivity</span>
                        <h4>Build Confidence With Expert Feedback</h4>
                        <p>
                            Constructive feedback from experienced mentors helps you refine
                            your skills and gain real-world confidence.
                        </p>
                        <div className="blog-meta">
                            <span>May 01, 2026</span>
                        </div>
                        <button onClick={() => navigate("/blog")}>
                            Read More →
                        </button>
                    </div>

                    {/* Right Bottom Tall Image */}
                    <div className="blog-card image-card right-tall">
                        <img src="https://images.unsplash.com/photo-1519337265831-281ec6cc8514?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8YmxvZ3xlbnwwfHwwfHx8MA%3D%3D" alt="" />
                        <div className="image-overlay">
                            <span className="blog-category">Technology</span>
                            <h4 style={{ color: "#fff" }}>The Future of Online Learning Platforms</h4>
                        </div>
                        <button onClick={() => navigate("/blog")}>
                            Read More →
                        </button>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default HomeBlogSection;